import Vue from 'vue';
let $http = Vue.prototype.$http;


// 登录
// export const Login = (params) => $http({
//     url:'index/login',
//     method:'post',
//     params
// }).then(res=>{
//     return res.data;
// })

// 我管理的项目
export const MngProjectList = (params) => $http.get('api/v1/front_project/my_project', {
    params
}).then(res => {
    return res.data
})

//我管理的班级
export const AdministratorClassList = (params) => $http.get('api/v1/front_project/my_project_class', {
    params
}).then(res => {
    return res.data
})

// 项目详情 

export const AdministratorProjectDetail = (params) => $http.get('api/v1/front_project/my_project_class', {
    params
}).then(res => {
    return res.data
})

// 学员学情统计
export const ClassStaffAchievementsList = (params) => $http.get('api/v1/statistics/class_staff_achievements_list', {
    params
}).then(res => {
    return res.data
})

// 基本数据
export const ClassStaffBaseStatistics = (params) => $http.get('api/v1/statistics/class_staff_base_statistics', {
    params
}).then(res => {
    return res.data
})

//学员参与情况统计 
export const ClassStaffAchievementsDetailList = (params) => $http.get('api/v1/statistics/class_staff_achievements_detail_list', {
    params
}).then(res => {
    return res.data
})

// 自定义头部显示
export const ClassStaffHeaderShowCustom = (params) => $http.get('api/v1/statistics/class_staff_header_show_custom', {
    params
}).then(res => {
    return res.data
})

// 导出学员参与情况统计
export const ClassStaffAchievementsDetailExport = (params) => $http({
    url: 'api/v1/statistics/class_staff_achievements_detail_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})


//班级报告头部 
export const ClassReportHeader = (params) => $http.get('api/v1/front_project/get_class_info', {
    params
}).then(res => {
    return res.data
})

// 项目管理员班级列表
export const ClassList = (params) => $http.get('api/v1/front_project/get_class_list', {
    params
}).then(res => {
    return res.data
})

// 专家基本数据
export const ExportBaseData = (params) => $http.get('api/v1/statistics/class_expert_satisfy', {
    params
}).then(res => {
    return res.data
})

// 满意度统计列表
export const SatisfactionList= (params) => $http.get('api/v1/statistics/class_expert_avg_satisfe_list', {
    params
}).then(res => {
    return res.data
})

// 满意度统计列表 导出
export const SatisfactionListExport = (params) => $http({
    url: 'api/v1/statistics/class_expert_avg_satisfe_list_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 满意度统计列表自定义表头
export const SatisfactionCustomList= (params) => $http.get('api/v1/statistics/class_expert_header_show', {
    params
}).then(res => {
    return res.data
})

// 专家个人统计
export const ExpertStatistics= (params) => $http.get('api/v1/statistics/class_expert_user_satisfy', {
    params
}).then(res => {
    return res.data
})

// 专家列表
export const ExpertList= (params) => $http.get('api/v1/statistics/class_expert_list', {
    params
}).then(res => {
    return res.data
})

// （选择题）详细
export const SelectQuestionDetail = (params) => $http.get('api/v1/statistics/class_expert_satisfy_detail_select', {
    params
}).then(res => {
    return res.data
})

// （选择题）详细自定义表头
export const SelectCustomHeader = (params) => $http.get('api/v1/statistics/class_satisfy_detail_select_header_show', {
    params
}).then(res => {
    return res.data
})

// （选择题）导出详细
export const SelectDetailExport = (params) => $http({
    url: 'api/v1/statistics/class_expert_satisfy_detail_select_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

//（填空题）详细列表
export const SelectDetailList = (params) => $http.get('api/v1/statistics/class_expert_satisfy_detail_blanks', {
    params
}).then(res => {
    return res.data
})

// （填空题）导出详细
export const FillQuestionDetailExport = (params) => $http({
    url: 'api/v1/statistics/class_expert_satisfy_detail_blanks_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 填空题详细自定义表头
export const FillDetailCustomHeader = (params) => $http.get('api/v1/statistics/class_satisfy_detail_blanks_header_show', {
    params
}).then(res => {
    return res.data
})

// 基地校基本数据
export const BaseSchoolData = (params) => $http.get('api/v1/statistics/class_school_satisfy', {
    params
}).then(res => {
    return res.data
})

// 基地校满意度统计
export const BaseSchoolSatisfactionList = (params) => $http.get('api/v1/statistics/class_school_avg_satisfe_list', {
    params
}).then(res => {
    return res.data
})

// 基地校满意度统计自定义表头
export const BaseSchoolSatisfactionCustomHeader = (params) => $http.get('api/v1/statistics/class_school_header_show', {
    params
}).then(res => {
    return res.data
})

// 基地校满意度统计导出
export const BaseSchoolSatisfactionExport = (params) => $http({
    url: 'api/v1/statistics/class_school_avg_satisfe_list_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 基地校列表
export const BaseSchoolList = (params) => $http.get('api/v1/statistics/class_school_list', {
    params
}).then(res => {
    return res.data
})

// 基地校个人统计
export const BaseSchoolUserData = (params) => $http.get('api/v1/statistics/class_school_user_satisfy', {
    params
}).then(res => {
    return res.data
})

// 基地校选择题列表
export const BaseSchoolSelectList = (params) => $http.get('api/v1/statistics/class_school_satisfy_detail_select', {
    params
}).then(res => {
    return res.data
})

// 基地校（选择题）导出详细
export const BaseSchoolSelectExport = (params) => $http({
    url: 'api/v1/statistics/class_school_satisfy_detail_select_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 基地校（填空题）详细
export const BaseSchoolFillList = (params) => $http.get('api/v1/statistics/class_school_satisfy_detail_blanks', {
    params
}).then(res => {
    return res.data
})

// 基地校（填空题）导出
export const BaseSchoolFillExport = (params) => $http({
    url: 'api/v1/statistics/class_school_satisfy_detail_blanks_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 后勤报告后勤服务的满意度统计
export const LogisticsHeader = (params) => $http.get('api/v1/statistics/class_attendance_satisfy', {
    params
}).then(res => {
    return res.data
})

// 后勤报告选择题列表
export const LogisticsChoiceList = (params) => $http.get('api/v1/statistics/class_attendance_satisfy_detail_select', {
    params
}).then(res => {
    return res.data
})

// 后勤报告选择题列表导出
export const LogisticsChoiceListExport = (params) => $http({
    url: 'api/v1/statistics/class_attendance_satisfy_detail_select_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 后勤报告（填空题）详细列表
export const LogisticsFillList = (params) => $http.get('api/v1/statistics/class_attendance_satisfy_detail_blanks', {
    params
}).then(res => {
    return res.data
})

// 后勤报告导出填空题明细
export const LogisticsFillExport = (params) => $http({
    url: 'api/v1/statistics/class_attendance_satisfy_detail_blanks_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 班主任报告满意度统计头部
export const TeacherSatisfactionStatistics = (params) => $http.get('api/v1/statistics/class_headmaster_satisfy', {
    params
}).then(res => {
    return res.data
})

// 班主任报告选择题列表
export const TeacherChoiceList = (params) => $http.get('api/v1/statistics/class_headmaster_satisfy_detail_select', {
    params
}).then(res => {
    return res.data
})


// 班主任报告导出选择题明细
export const TeacherChoiceExport = (params) => $http({
    url: 'api/v1/statistics/class_headmaster_satisfy_detail_select_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 班主任报告填空题列表
export const TeacherFillList = (params) => $http.get('api/v1/statistics/class_headmaster_satisfy_detail_blanks', {
    params
}).then(res => {
    return res.data
})

// 班主任报告导出填空题明细
export const TeacherFillExport = (params) => $http({
    url: 'api/v1/statistics/class_headmaster_satisfy_detail_blanks_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 项目报告基本数据
export const ProjectBaseData = (params) => $http.get('api/v1/statistics/project_report_base', {
    params
}).then(res => {
    return res.data
})

// 项目报告满意度统计
export const ProjectSatisfactionStatistics = (params) => $http.get('api/v1/statistics/project_report_satisfy', {
    params
}).then(res => {
    return res.data
})

// 项目报告选择题列表
export const ProjectChoiceList = (params) => $http.get('api/v1/statistics/project_report_satisfy_detail_select', {
    params
}).then(res => {
    return res.data
})

// 项目报告导出选择题明细
export const ProjectChoiceExport = (params) => $http({
    url: 'api/v1/statistics/project_report_satisfy_detail_select_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 项目报告填空题列表
export const ProjectFillList = (params) => $http.get('api/v1/statistics/project_report_satisfy_detail_blanks', {
    params
}).then(res => {
    return res.data
})

// 项目报告导出填空题明细
export const ProjectFillExport = (params) => $http({
    url: 'api/v1/statistics/project_report_satisfy_detail_blanks_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})


// 考勤报告基本数据
export const CheckWorkBaseData = (params) => $http.get('api/v1/statistics/class_attendance_report_base', {
    params
}).then(res => {
    return res.data
})

// 考勤报告出勤情况统计
export const CheckWorkAttendanceList = (params) => $http.get('api/v1/statistics/class_sign_report_list', {
    params
}).then(res => {
    return res.data
})

// 考勤报告出勤情况统计导出
export const CheckWorkAttendanceListExport = (params) => $http({
    url: 'api/v1/statistics/class_sign_report_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 考勤报告出勤明细列表
export const CheckWorkAttendanceDetailList = (params) => $http.get('api/v1/statistics/class_attendance_report_list', {
    params
}).then(res => {
    return res.data
})

// 考勤报告出勤明细自定义表头
export const CheckWorkAttendanceDetailCustomList = (params) => $http.get('api/v1/statistics/class_attendance_report_header', {
    params
}).then(res => {
    return res.data
})

// 考勤报告出勤明细导出
export const CheckWorkAttendanceDetailListExport = (params) => $http({
    url: 'api/v1/statistics/class_attendance_report_list_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 学习成果报告基本数据
export const StudyAchievementBaseData = (params) => $http.get('api/v1/statistics/class_learning_outcomes_base_data', {
    params
}).then(res => {
    return res.data
})

// 学习成果报告作业/问卷提交情况统计
export const StudyAchievementCommitDetail = (params) => $http.get('api/v1/statistics/class_learning_outcomes_statistics', {
    params
}).then(res => {
    return res.data
})

// 学习成果报告作业/问卷提交情况统计导出
export const StudyAchievementCommitDetailExport = (params) => $http({
    url: 'api/v1/statistics/class_learning_outcomes_statistics_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 学习成果报告作业/问卷提交情况明细
export const StudyAchievementCommitDetailList = (params) => $http.get('api/v1/statistics/class_learning_outcomes_wq_detail', {
    params
}).then(res => {
    return res.data
})

// 学习成果报告作业/问卷提交情况明细自定义表头
export const StudyAchievementCommitDetailCustomList = (params) => $http.get('api/v1/statistics/class_learning_outcomes_header', {
    params
}).then(res => {
    return res.data
})

//  学习成果报告作业/问卷提交情况明细导出
export const StudyAchievementCommitDetailListExport = (params) => $http({
    url: 'api/v1/statistics/class_learning_outcomes_wq_detail_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 学习成果报告风采墙
export const StudyAchievementWallStyleList = (params) => $http.get('api/v1/statistics/class_learning_outcomes_class_ring', {
    params
}).then(res => {
    return res.data
})

// 学习成果报告班级圈置顶帖子

export const StudyAchievementPostList = (params) => $http.get('api/v1/statistics/class_learning_outcomes_is_top', {
    params
}).then(res => {
    return res.data
})

// 学习成果报告自发组织讨论组明细
export const StudyAchievementDiscussionList = (params) => $http.get('api/v1/statistics/class_learning_outcomes_custom_discuss', {
    params
}).then(res => {
    return res.data
})

// 学习成果报告自发组织讨论组明细导出
export const StudyAchievementDiscussionListExport = (params) => $http({
    url: 'api/v1/statistics/custom_discussList_export',
    method: 'get',
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data;
})

// 学习成果报告风采墙导出
export const StudyAchievementWallStyleExport = (params) => $http.get('api/v1/statistics/class_ring_export', {
    params
}).then(res => {
    return res.data
})

// 培训效果报告基本数据
export const TrainEffectBaseData = (params) => $http.get('api/v1/statistics/project_report_base', {
    params
}).then(res => {
    return res.data
})

// 培训效果报告学习情况分析统计列表
export const TrainEffectStudyStatisticsList = (params) => $http.get('api/v1/statistics/analysis_statistics_list', {
    params
}).then(res => {
    return res.data
})

// 培训效果报告学习情况分析统计列表导出
export const TrainEffectStudyStatisticsListExport = (params) => $http.get('api/v1/statistics/analysis_statistics_list_export', {
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data
})

// 培训效果报告成绩得分统计列表
export const TrainEffectStudyScoreList = (params) => $http.get('api/v1/statistics/class_achievements_list', {
    params
}).then(res => {
    return res.data
})

// 培训效果报告成绩得分统计列表自定义表头
export const TrainEffectStudyScoreCustomList = (params) => $http.get('api/v1/statistics/class_achievements_header_show', {
    params
}).then(res => {
    return res.data
})

// 培训效果报告成绩得分统计列表导出
export const TrainEffectStudyScoreListExport = (params) => $http.get('api/v1/statistics/class_achievements_list_export', {
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data
})

// 我管理的班级的导出
export const AdministratorMngClassExport = (params) => $http.get('api/v1/front_project/my_project_class_excel', {
    params,
    responseType: 'blob', // 格式
}).then(res => {
    return res.data
})


// 面授课列表提示
export const ExpertFaceList = (params) => $http.get('api/v1/statistics/class_expert_join_face_list', {
    params
}).then(res => {
    return res.data
})
